import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { BiArrowBack } from "react-icons/bi";

const AddUserSubscription = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [loading, setLoading] = useState(false);
  const [loader, setShowLoader] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState(false);
  const [isAccess, setIsAccess] = useState(0);
  const [plans, setPlans] = useState<any>([]);
    const userId = location.state?.userId;
    console.log("userId", userId)
  useEffect(() => {
    planList();
    if (id !== "add") 
       userdetails();
    planList();
  }, []);

  const userdetails = () => {
    setLoading(true);
 //alert("F")
    WebService.getAPI({
      action: `/user-subscriptions/${id}`,
    })
      .then((res: any) => {
        setLoading(false);
        setData(res.result);

       setValue("subscription_id", res.data.subscription_id);

        setValue("start_date", res.data.start_date);
                setValue("end_date", res.data.end_date);

      })  
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };

  const planList = () => {
    setLoading(true);

    WebService.getAPI({
      action: `/subscription/list`,
    })
      .then((res: any) => {
        setLoading(false);
        setPlans(res.list || []);
      })
      .catch((e) => {
        setPlans([]);
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  // ...existing code...
  const onSave = async (form: any) => {
    const payload = {
      uuid: id,
          subscription_id: form.subscription_id,
          start_date: form.start_date,
          end_date : form.end_date
    };

    setShowLoader(true);
    try {
      if (id !== "add") {
        // Update
        const res: any = await WebService.postAPI({
          action: `/user-subscription/update`,
          body: payload,
        });

        toast.success(res.message);
        setShowLoader(false);

        navigate(-1);
      } else {
        // Add
        const addPayload = {
          subscription_id: form.subscription_id,
          start_date: form.start_date,
          user_id : userId,
           end_date : form.end_date
          
        };

        const res: any = await WebService.postAPI({
          action: `/user-subscription/add`,
          body: addPayload,
        });

        toast.success(res.message || "User Subscription added successfully");
         navigate(-1);
        setShowLoader(false);

        navigate(-1);
      }
    } catch (e: any) {
      setShowLoader(false);
      toast.error(e?.response?.message || "Something went wrong");
      setError(true);
    }
  };

  return (
    <Container className="mt-5">
      {/* BACK BUTTON */}
      <Row className="align-items-center mb-4">
        <Col xs="auto">
          <Link
            to={`/manage-customers`}
            className="d-flex align-items-center text-decoration-none"
          >
            <BiArrowBack size={22} className="me-2 text-dark" />
            <span className="text-dark">Back</span>
          </Link>
        </Col>

        <Col className="text-center">
          <h1 className="font-20 font-bold m-0">
            {id !== "add"
              ? "Update User Subscription"
              : "Add User Subscription"}
          </h1>
        </Col>

        <Col xs="auto"></Col>
      </Row>

      {/* FORM */}
      <Row className="justify-content-center">
        <Col lg={10}>
          <Loader show={loading} />

          <Card className="p-4 shadow-sm">
            <Form onSubmit={handleSubmit(onSave)}>
              <Row className="mb-3 mt-4">
                <Col lg={12}>
                  <Form.Group controlId="courseType">
                    <Form.Label>Subscription plan</Form.Label>
                    <Form.Select
                      {...register("subscription_id", { required: true })}
                    >
                      <option value="">Select plan</option>
                      {plans.map((x: any) => (
                        <option key={x.id} value={x.id}>
                          {x.name} {x.duration} month
                        </option>
                      ))}
                    </Form.Select>

                    {errors.course_id && (
                      <small className="text-danger">
                        Please select a plan
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="start_date">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      {...register("start_date", { required: true })}
                    />
                    {errors.start_date && (
                      <small className="text-danger">
                        Start date is required
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="end_date">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      {...register("end_date", { required: true })}
                    />
                    {errors.start_date && (
                      <small className="text-danger">
                        End date is required
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              {/* SAVE / UPDATE BUTTON */}
              <Button
                type="submit"
                className="btn btn-brand-1 d-block mx-auto mt-3"
                disabled={loader}
              >
                {loader && <Spinner size="sm" className="me-2" />}{" "}
                {id !== "add" ? "Update" : "Save"}
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddUserSubscription;
